module.exports = __webpack_public_path__ + "static/media/S2N14-2.0f4f9f1d.svg";